/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RsaDevice } from '../../models/rsa-device';

export interface GetRsaDevice$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getRsaDevice(http: HttpClient, rootUrl: string, params: GetRsaDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RsaDevice>> {
  const rb = new RequestBuilder(rootUrl, getRsaDevice.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RsaDevice>;
    })
  );
}

getRsaDevice.PATH = '/api/v1/rsa/devices/{id}';
